import React from 'react';
import './no-reviews.scss';

const NoReviews = ({stars, type}) => {
    // if we have reviews, return null - don't print
    if (stars && stars.size > 0) {
        return null;
    }

    const typeString = type ? i18n.t(`reviews.gigs._inner_gig.drop_${type}`) : i18n.t('reviews.general.reviews');

    return (
        <div className="no-reviews">
            {i18n.t('reviews.users.user_show.reviews_not_found', {type: typeString})}
        </div>
    );
};

export default NoReviews;



// WEBPACK FOOTER //
// ./src/reviews/no_reviews/NoReviews.js